import React, { useEffect } from "react";
import { Typography } from "@mui/material";
const AiGeneratedContent = ({ content }) => {
  const text_for_text_model = "Text Model: Gemini 1.5 Pro";
  const text_for_image_model = "Image Model: Imagen 3";
  return (
    <div className="flex flex-row-reverse text-xs text-[#000000] mt-1">
      <Typography
        sx={{ fontWeight: 400, fontSize: "0.75rem", lineHeight: "1rem" }}
      >
        {content ? text_for_text_model : text_for_image_model}
      </Typography>
    </div>
  );
};

export default AiGeneratedContent;
